import { EInputType, Input, KitIcons } from '@repo/apg-ui';
import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import './RadioSelect.scss';
import { useIntl } from 'react-intl';

const DiscountSelector = ({ discountOptions, discountCode, updateDiscount }) => {
  const [selectedDiscount, setSelectedDiscount] = useState(discountCode);
  const [isOpen, setIsOpen] = useState(false);
  const intl = useIntl();

  const handleSelect = (eventKey) => {
    setSelectedDiscount(eventKey);
    updateDiscount(eventKey);
    setIsOpen(false);
  };

  const toggleOpen = () => setIsOpen(!isOpen);

  const getDiscountLabel = (code) => {
    const discount = discountOptions.find((d) => d.code === code);
    return discount
      ? discount.label
      : intl.formatMessage({ id: 'ec.basket.selectDiscount', defaultMessage: 'Rabatt auswählen' });
  };
  return (
    <Dropdown onSelect={handleSelect} onToggle={toggleOpen} show={isOpen} drop='up' className='custom-dropdown'>
      <Dropdown.Toggle className='customSelect d-flex justify-content-between align-items-center'>
        {selectedDiscount
          ? `${getDiscountLabel(selectedDiscount)}`
          : intl.formatMessage({ id: 'ec.basket.selectDiscount', defaultMessage: 'Rabatt auswählen' })}
        {isOpen ? <KitIcons.ChevUpIcon /> : <KitIcons.ChevDownIcon />}
      </Dropdown.Toggle>

      <Dropdown.Menu className='customDropdown'>
        {discountOptions.map((discount) => (
          <Dropdown.Item key={discount.code} eventKey={discount.code} className='customRadioInput'>
            <Input
              type='radio'
              inputType={EInputType.Radio}
              name='discountRadio'
              checked={selectedDiscount == discount.code}
              radioOptions={[
                {
                  checked: selectedDiscount == discount.code,
                  value: discount.code,
                  onChange: (_, value) => setSelectedDiscount(value),
                  radioExtraStyles: 'modal-input-radio',
                },
              ]}
            >
              {discount.label}
            </Input>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DiscountSelector;
